import React from 'react';

import {Avatar} from 'src/components/avatar/avatar';
import {UserName} from 'src/components/user-name/user-name';
import {getUsersInfo} from 'src/modules/users-info/services';
import {ChangeRequestSubscription} from 'src/openapi/models/ChangeRequestSubscription';
import {EventSubscription} from 'src/openapi/models/EventSubscription';
import {useAppSelector} from 'src/store';

import {Group, Item} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';

type Props = {
    watcher: ChangeRequestSubscription | EventSubscription,
    onRemove: (subscriptionId: number) => void,
};

export const WatcherView = ({watcher, onRemove}: Props) => {
    const userEmail = watcher.userEmail;
    const user = useAppSelector(getUsersInfo)?.[userEmail];

    const onRemoveWatcher = () => {
        if (watcher.id) {
            onRemove(watcher.id);
        }
    };

    return (
        <>
            {watcher.id ? (
                <Item style={{width: '19rem'}}>
                    <Group className="pdx-m" alignItems="center">
                        <Avatar user={user}/>
                        <Item style={{minWidth: '70%', maxWidth: '70%'}} className="pt-s pb-xs">
                            <UserName email={userEmail}/>
                        </Item>
                        <BasicIconButton iconProps={{type: Icons.TRASH_LIGHT}} onClick={onRemoveWatcher}/>
                    </Group>
                </Item>
            ) : null}
        </>
    );
};
